import React from "react"

const IconArrowActionableThick = () => (
<svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.92753 4.025L5.96353 1.577L0.869531 6.725L0.221531 6.059L5.35153 0.929L2.89453 0.965V0.11H6.80053V4.025H5.92753Z"/>
</svg>
)

export default IconArrowActionableThick